<template>
	<div class="home">
		<div class="container">
			<div class="row">
				<div class="col-12 p-md-0">
					<div v-if="Object.keys(productOne).length == 0" class="col-12 pt-3 pb-3 p-md-3 mb-3 mb-md-5 rounded background-white top-slider shadow d-md-flex flex-wrap">
						<div class="col-12 justify-content-center offset-md-0 col-md-5 pl-md-4 pt-3 pb-3">
							<vcl v-show="true" :width="100" :height="100">
								<rect x="0" y="0" rx="1" ry="1" width="100%" height="100%" />
							</vcl>
						</div>
						<div class="col-12 col-md-7 p-0 p-md-3 font-size-sm-10 text-center pt-3 mt-auto mb-auto">
							<vcl v-show="true" :width="100" :height="70">
								<rect x="15" y="18" rx="1" ry="1" width="70" height="8" />
								<rect x="26" y="28" rx="1" ry="1" width="50" height="6" />
								<rect x="43" y="37" rx="1" ry="1" width="14" height="3" />
								<rect x="20" y="41" rx="1" ry="1" width="60" height="10" />
							</vcl>
						</div>
						<div class="col-12 pt-5 pb-3">
							<ul class="nav nav-pills mb-3 text-center font-size-13 font-size-sm-8" id="pills-tab" role="tablist">
								<li class="col col-md-3 p-0 nav-item border-left border-top border-bottom">
									<a class="nav-link no-border-radius color-gray active" id="pills-deskripsi-tab" data-toggle="pill" href="#pills-deskripsi" role="tab" aria-selected="true">Deskripsi</a>
								</li>
							</ul>
							<vcl v-show="true" :width="200" :height="40">
								<rect x="0" y="0" rx="1" ry="1" width="200" height="2"/>
								<rect x="0" y="4" rx="1" ry="1" width="200" height="2"/>
								<rect x="0" y="8" rx="1" ry="1" width="180" height="2"/>
							</vcl>
						</div>
					</div>
					<div v-if="Object.keys(productOne).length > 0" class="col-12 pt-3 pb-3 p-md-3 mb-3 mb-md-5 rounded background-white top-slider shadow d-md-flex flex-wrap">
						<div class="offset-2 col-8 justify-content-center offset-md-0 col-md-1 pr-0 pt-3 d-none d-md-block" v-viewer="{movable: false, toolbar: false, fullscreen: true, toolbar: false, title:false}">
							<a href="javascript:;" v-for="(img, index) in productOne.product_image" :key="index" class="hov-brightness">
								<img class="img-fluid pb-3 rounded" :src="img.product_image_filename" alt="">
							</a>
						</div>
						<div class="col-12 justify-content-center offset-md-0 col-md-5 pl-md-4 pt-3 pb-3" v-viewer="{movable: false, toolbar: false, fullscreen: true, toolbar: false, title:false}">
							<img class="img-fluid w-100" :src="productOne.product_image_filename" alt="product">
						</div>
						<div class="col-12 col-md-6 col-lg-5 p-0 p-md-3 font-size-sm-10 text-center pt-3 mt-auto mb-auto">
							<div class="col-12 pl-0 pr-0">
								<div class="color-mila font-weight-bold font-size-22 font-size-sm-15">{{ productOne.product_name }}</div>
								<div class="color-purple font-size-20 font-size-sm-13 pt-3 f-lato">Rp {{ productOne.product_price | toNumber }} / {{ productOne.product_unit }}</div>
								<div class="color-black pt-3 font-size-14 font-size-sm-11 f-lato">{{ productOne.product_weight | toKg }}</div>
								<div class="col-10 offset-1 col-md-12 offset-md-0 col-lg-10 offset-lg-1 pt-3">
									<button class="col-12 btn background-button-template color-white box-purple pt-md-3 pb-md-3" @click="scrollMc">
										<span class="font-size-12 font-size-sm-10">BELI SEKARANG</span>
									</button>
								</div>
							</div>
						</div>
						<div class="col-12 pt-5 pb-3">
							<ul class="nav nav-pills mb-3 text-center font-size-13 font-size-sm-8" id="pills-tab" role="tablist">
								<li class="col col-md-3 p-0 nav-item border-left border-top border-bottom">
									<a class="nav-link no-border-radius color-gray active" id="pills-deskripsi-tab" data-toggle="pill" href="#pills-deskripsi" role="tab" aria-selected="true">Deskripsi</a>
								</li>
								<!-- <li class="col col-md-3 p-0 nav-item border-left border-top border-bottom">
									<a class="nav-link no-border-radius color-gray" id="pills-kegunaan-tab" data-toggle="pill" href="#pills-kegunaan" role="tab" aria-selected="false">Kegunaan</a>
								</li>
								<li class="col-4 col-md-3 p-0 nav-item border-left border-top border-bottom border-right">
									<a class="nav-link no-border-radius color-gray pl-0 pr-0 pr-md-3 pl-md-3" id="pills-contact-tab" data-toggle="pill" href="#pills-cara" role="tab" aria-selected="false">Cara Pemakaian</a>
								</li> -->
							</ul>
							<div class="tab-content color-black font-size-13 font-size-sm-9" id="pills-tabContent">
								<div class="tab-pane fade show active" id="pills-deskripsi" role="tabpanel" aria-labelledby="pills-home-tab">{{ productOne.product_description }}</div>
								<div class="tab-pane fade" id="pills-kegunaan" role="tabpanel">Lorem ipsum dolor sit, amet consectetur adipisicing elit. Possimus neque nostrum quos debitis tempore voluptatem veniam id. Dolorum dolor veniam molestiae libero neque? Sapiente excepturi dolore dolor odit, reprehenderit tenetur?</div>
								<div class="tab-pane fade" id="pills-cara" role="tabpanel">Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis, et. Ipsum repellendus esse eos commodi eligendi veritatis harum delectus non perspiciatis? Unde, possimus natus reprehenderit quis doloribus id saepe. Asperiores!</div>
							</div>
						</div>
					</div>
					<div class="col-12 text-center color-black font-size-22 font-size-sm-15 font-weight-bold pt-3 pb-3 pb-md-4 text-uppercase mobile-counter">
						Mobile counter
					</div>
					<div class="col-12 p-0 p-md-3 pb-3 mt-md-2 d-md-flex background-white cus-box-shadow rounded">
						<div class="col-12 col-md-5 d-md-flex p-0 pt-2 pl-md-0 pt-md-3 pb-md-3 p-lg-3">
							<div class="col-12 col-md-3 pr-0 pt-3 pt-md-1 font-size-sm-11 d-none d-lg-block">
								<img src="/assets/icon/filter.svg" alt="" class="img-fluid pr-2">Filter
							</div>
							<div class="col-12 col-md-12 col-lg-9 pt-2 pt-md-0 pl-md-0 pl-lg-3">
								<input type="text" v-model="kode.value" class="form-control form-control-sm box-purple" placeholder="Nama / Kode Mobile Counter" @keyup.enter="cari()">
							</div>
						</div>
						<div class="col-12 col-md-7 d-md-flex p-0 pl-md-0 p-lg-3 pt-md-3">
							<div class="col-12 col-md-8 pl-md-0 pr-md-0 pr-lg-4 pt-2 pt-md-0">
								<v-select label="province" class="font-size-10" :reduce="provinces => provinces.province_id" :options="provinces" v-model="provinsi.value" placeholder="Pilih Provinsi">
									<template v-slot:no-options="{ search, searching }">
										<template v-if="searching">
											Tidak ada kata yang cocok untuk <em>{{ search }}</em>.
										</template>
										<em style="opacity: 0.5;" v-else>Ketik untuk mencari Provinsi</em>
									</template>
								</v-select>
							</div>
							<div class="col-12 col-md-4 pt-2 pt-md-0 pr-md-0">
								<button class="col-12 btn btn-sm rounded background-button-template color-white box-purple" @click="cari()">
									<i class="fas fa-search mr-2"></i><span class="font-size-12 font-size-sm-11">Cari</span>
								</button>
							</div>
						</div>
					</div>
					<div class="col-12 pb-4 pl-0 pr-0">
						<div class="container p-0">
							<div class="row" v-show="allStockist.length == 0">
								<SkeletonStockist class="col-6 col-md-4 col-lg-3 mt-md-4 mt-3 pl-2 pr-2 pl-md-3 pr-md-3" v-for="n in 8" :key="'sekeleton'+n"/>
							</div>
							<div class="row" v-if="allStockist == 'error'">
								<div class="col-12 pb-2 mt-md-4 mt-3">
									<div class="col-12 p-0 background-white rounded cus-box-shadow pb-2">
										<div class="col-12 d-flex justify-content-center">
											<div class="col-9 col-md-4 mt-1 pt-4 text-center">
												<img src="/assets/icon/mobile_counter_notfound.svg" class="img-fluid">
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="row" v-else>
								<div class="col-12 pr-0 d-flex flex-wrap">
									<div class="col-6 col-md-4 col-lg-3 pl-0 mt-md-4 mt-3" v-for="(stockist, index) in allStockist" :key="index">
										<div class="col-12 pl-0 pr-0 output-search rounded">
											<div class="output-search-hover position-absolute rounded pt-3">
												<div class="col-12 p-0 text-center">
													<div class="col-12 color-mila text-center pb-2">
													</div>
													<div class="col-12 color-mila text-center pb-2">
														<div class="font-size-15 font-size-sm-12">Stok {{stockist.stock_store >= 25 ? 'Tersedia' : 'Terbatas'}}</div>
													</div>
													<button class="col-11 col-md-8 btn background-button-template color-white box-purple" @click="beliDisini(stockist)">
														<div class="pt-1 pb-1"><i class="fas fa-shopping-cart mr-2"></i>
															Beli Disini
														</div>
													</button>
												</div>
											</div>
											<div class="col-12 p-0 border output-search-nohover rounded cus-box-shadow">
												<div class="col-12 p-3 p-md-4 text-center">
													<img class="img-fluid img-thumb-stockist ma-md-height-220 height-sm-130 rounded" :src="stockist.stockist_image" alt="stockist">
													<span v-if="parseInt(stockist.stockist_distance_km.replace('.','')) < 999999" class="badge-location color-black font-size-12 font-size-sm-9 f-lato">{{stockist.stockist_distance_km}} km</span>
												</div>
												<div class="col-12 text-center color-mila font-size-14 font-size-sm-10 mt-n1 f-lato">
													<b><span id="idMember">{{stockist.stockist_code}}</span></b>
												</div>
												<div class="col-12 text-center font-size-13 font-size-sm-9">
													<b><div id="idStockis" class="stockist-name">{{stockist.stockist_name}}</div></b>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12 text-center pb-4 pt-2" v-if="pagination.next > 0">
						<a href="javascript:;" class="btn background-button-template box-purple" @click="tampilbanyak">
							<div class="text-capitalize color-white font-size-10">
								<i class="fas fa-sync mr-2"></i>
								<span class="">Muat lebih banyak</span>
							</div>
						</a>
					</div>
					<last-seen></last-seen>
					<ml-partner-us></ml-partner-us>
				</div>
			</div>
		</div>
		<VModal ref="modalBeliDisini" class="modal-sm-90vh">
			<template v-slot:header>
				<div> </div>
			</template>
			<template v-slot:body>
				<div class="col-12 pt-2 pt-md-4 pb-4 d-md-flex">
					<div class="col-12 col-md-4 pl-0 pr-0 pr-md-3">
						<img :src="productOne.product_image_filename" alt="produk" class="w-100">
						<div class="col-12 position-absolute z-index-1 pl-0 pr-0 pr-md-3 bottom-0">
							<div class="col-12 background-gray-dark text-center color-white rounded pt-2 pb-2">
								<div class="f-lato">{{selectedStockist.stockist_code}}</div>
								<div class="font-size-9">{{selectedStockist.stockist_name}}</div>
								<div v-if="selectedStockist.stockist_origin_city_name && selectedStockist.stockist_origin_province_name" class="font-size-9"><i class="fas fa-map-marker-alt mr-2"></i>{{selectedStockist.stockist_origin_city_name}}, {{selectedStockist.stockist_origin_province_name}}</div>
							</div>
						</div>
					</div>
					<div class="col-12 col-md-8 pl-0 pl-md-3 pr-0 pr-md-3 pt-3 pt-md-0">
						<div class="color-mila font-size-16 font-size-sm-13 font-weight-bold">{{ productOne.product_name }}</div>
						<div class="color-purple font-size-14 font-size-sm-11 pt-1 pt-md-2 f-lato">Rp {{ productOne.product_price | toNumber }} / {{ productOne.product_unit }}</div>
						<div class="color-black font-size-13 font-size-sm-11 pt-1 pt-md-2 f-lato">{{ productOne.product_weight | toKg }}</div>
						<div class="col-12 d-flex pt-2 pt-md-3 pl-0">
							<div class="col-4 col-md-2 color-black font-size-13 pt-1 pl-0">Jumlah</div>
							<div class="col-8 col-md-5 input-group mb-3">
								<div class="input-group-prepend" id="down">
									<button :disabled="qty_product <= 1" class="btn background-purple color-white" @click="qty_product--">
										<span class="font-size-8"><i class="fas fa-minus"></i></span>
									</button>
								</div>
								<input @keypress="onlyNumber" v-model="qty_product" type="text" class="form-control text-center no-box-shadow font-size-12 font-size-sm-10 number box-purple" aria-label="Amount" id="jumlahValue" placeholder="0" value="1">
								<div class="input-group-append" id="up">
									<button class="btn background-purple color-white" @click="qty_product++">
										<span class="font-size-8"><i class="fas fa-plus"></i></span>
									</button>
								</div>
								<Alert empty :content="alerts"/>
							</div>
						</div>
						<div class="col-12 pl-0 pr-0 d-md-flex pt-2 pt-md-3">
							<div class="col-12 col-md-4 pl-0 pr-0 pr-md-3">
								<button class="col-12 btn btn-outline-danger rounded pt-2 pb-2 text-capitalize" @click="modalHide">
									<i class="fa fa-times mr-3"></i>
									<span class="font-size-11">Batal</span>
								</button>
							</div>
							<div class="col-12 col-md-6 pr-0 pt-2 pt-md-0 pl-0 pl-md-3 pr-0 pr-md-3">
								<button @click="insertCart()" class="col-12 btn background-button-template rounded pt-2 pb-2 color-white text-capitalize box-purple">
									<i class="fas fa-shopping-cart mr-3"></i>
									<span class="font-size-11">Masukkan Keranjang</span>
								</button>
							</div>
						</div>
					</div>
					
				</div>
			</template>
			<template v-slot:footer>
				<div> </div>
			</template>
		</VModal>
		<VModal ref="modalBerhasilDitambah" class="modal-big" modalHigh>
			<template v-slot:header>
				<div class="modal-header justify-content-center">
					<h5 class="modal-title text-uppercase">produk berhasil ditambahkan</h5>
					<button class="btn btn-no-box"> <img src="../../assets/modal_x.svg" class="close-modal ml-2 mt-n1" @click="() => $refs.modalBerhasilDitambah.modalHide()"></button>
				</div>
			</template>
			<template v-slot:body>
				<CartSuccess from="product" :addedProduct="productOne" :recommend="recomendedProduct.filter(el=> el.product_code != $route.params.code)"/>
				</template>
				<template v-slot:footer>
					<div></div>
				</template>
			</VModal>
			<VModal ref="modalKonfirmasiKeranjang" class="modal-small">
				<template v-slot:header>
					<div></div>
				</template>
				<div slot="body" class="col-12 mb-3">
					<div class="col-12 d-md-flex" v-if="cart">
						<div class="col-5 m-auto pt-md-3 pl-0 pl-md-3 pr-md-3 pr-0">
							<img class="img-fluid" src="/assets/icon/surprise-woman.svg">
						</div>
						<div class="col-12 col-md-7 pt-3 color-black m-auto text-md-left text-center pl-0 pr-0 pl-md-3 pr-md-3">
							<div class="font-size-sm-11 pt-2">Yakin ingin merubah order dari <b>{{cart[0].stockist_name}}</b> menjadi <b>{{selectedStockist.stockist_name}}</b>?</div>
						</div>
					</div>
				</div>
				<div slot="footer">
					<div class="modal-footer justify-content-center justify-content-md-end">
						<button class="col-6 col-md-3 btn btn-outline-danger rounded mr-1 font-size-sm-9 pr-md-4 pl-md-4 text-capitalize box-purple" type="button" @click="$refs.modalKonfirmasiKeranjang.modalHide()">
							<i class="fa fa-times mr-1"></i>Batal
						</button>
						<button class="col-6 col-md-3 btn background-button-template color-white rounded font-size-sm-9 pr-md-4 pl-md-4 text-capitalize" type="button" @click="konfirmasiKeranjang">
							<i class="fa fa-check mr-1"></i>Ya
						</button>
					</div>
				</div>
			</VModal>
		</div>
	</template>

	<script>
	import MlPartnerUs from '@/components/MlPartnerUs.vue';
	import LastSeen from '@/components/LastSeen.vue';
	import VModal from '@/components/VModal';
	import Alert from '@/components/Alert';
	import CartSuccess from '@/components/AddCartSuccess';
	import $ from 'jquery';
	import SkeletonStockist from '@/components/Skeleton/SkeletonStockist';
	import { mapState, mapMutations, mapActions } from 'vuex';
	import { client } from '@/api/client';
	import interceptors from '@/api/interceptors';

	export default {
		name: 'home',
		components: {
			MlPartnerUs, VModal, LastSeen, Alert, SkeletonStockist, CartSuccess
		},
		data () {
			return {
				temp: '',
				qty_product: 1,
				selectedStockist : '',
				kode:{
					value:'',
					comparison:'=',
					type:'string',
					field:'stockist_code'
				},
				provinsi:{
					value:'',
					comparison:'=',
					type:'string',
					field:'stockist_origin_province_id'
				},
				params:[],
				currentPage:1,
				total_page:0,
				readyToLoad: true,
				page:1,
				dataSponsor: '',
				dataProspect: '',
			}
		},
		computed: {
			...mapState('product', ['productOne', 'recomendedProduct']),
			...mapState('stockist', ['allStockist', 'provinces', 'pagination']),
			...mapState('cart', ['alerts', 'cart']),
			...mapState('maps', ['location'])
		},
		methods: {
			...mapActions('stockist', ['getStockistByProduct', 'search', 'getStockistByProvince', 'getMoreAllStockist']),
			...mapActions('product', ['getProductDetail']),
			...mapActions('cart', ['saveCart']),
			...mapMutations('cart', ['resetAlert', 'setAlert']),

			cari(){
				this.params = []
				if(this.provinsi.value) {
					this.params.push(this.provinsi)
				}
				if(this.kode.value) {
					this.params.push(this.kode)
				}
				this.search({
					product_code: this.$route.params.code,
					filter: this.params,
					lat: this.location.lat,
					lng: this.location.lng
				})
			},
			tampilbanyak() {
				this.page++;
				this.getMoreAllStockist({
					product_code: this.$route.params.code,
					page: this.page,
					limit: 12,
					filter: this.params,
					lat: this.location.lat,
					lng: this.location.lng
				});
			},
			scrollToTop() {
				window.scrollTo(0,0);
			},
			beliDisini(val) {
				this.resetAlert();
				this.qty_product = 1
				this.selectedStockist = val
				this.$refs.modalBeliDisini.modalShow()
			},
			konfirmasiKeranjang(){
				this.$refs.modalKonfirmasiKeranjang.modalHide()
				this.addCart(this.temp)
			},
			insertCart(){
				this.productOne['quantity'] = this.qty_product
				this.productOne['message'] = ''
				this.productOne['stock_store'] = this.selectedStockist.stock_store
				this.temp = {
					stockist_code : this.selectedStockist.stockist_code,
					stockist_id : this.selectedStockist.stockist_network_id,
					stockist_name : this.selectedStockist.stockist_name,
					stockist_prov : this.selectedStockist.stockist_origin_province_name,
					stockist_city : this.selectedStockist.stockist_origin_city_name,
					products : this.productOne
				}
				if (this.cart) {
					let indexStockist = this.cart.findIndex(x => x.stockist_code == this.selectedStockist.stockist_code)
					if (indexStockist < 0) {
						if (parseInt(this.temp.products.stock_store) < parseInt(this.temp.products.quantity)){
							let alert = 'Maksimal ' + this.temp.products.stock_store;
							this.setAlert(alert)
						} else {
							this.$refs.modalBeliDisini.modalHide()
							this.$refs.modalKonfirmasiKeranjang.modalShow()
						}
					} else {
						this.addCart(this.temp)
					}
				} else {
					this.addCart(this.temp)
				}
			},
			addCart(val){
				this.saveCart(val).then(()=>{
					if(!this.alerts){
						this.$refs.modalBeliDisini.modalHide()
						this.$refs.modalBerhasilDitambah.modalShow()
					}
				})
			},
			modalHide() {
				this.$refs.modalBeliDisini.modalHide()
			},
			scrollMc() {
				var mc = $('.mobile-counter').offset().top;
				mc -= 90;
				$('html').scrollTop(mc);
			},
			cekSponsor(){
				this.$store.commit('PROGRESS_START')
				client.interceptors.request.use(interceptors.noAuth, interceptors.onError);
				client.get('/tunnel/api/public/transaction/check_sponsor', {
					params: {
						sponsor_mid: this.dataSponsor
					}
				}).then(({ data: { data } }) => {
					localStorage.setItem('sponsor_data', JSON.stringify(data));
					this.$store.commit('PROGRESS_FINISH')
				}).catch(() => {
					localStorage.setItem('sponsor_data', {});
					this.$store.commit('PROGRESS_FAIL')
				});
			},
			cekProspect(){
				this.$store.commit('PROGRESS_START')
				client.interceptors.request.use(interceptors.noAuth, interceptors.onError);
				client.get('/tunnel/api/public/transaction/check-prospek', {
					params: {
						prospek_id: this.dataProspect
					}
				}).then(({ data: { data } }) => {
					localStorage.setItem('prospect_data', JSON.stringify(data));
					this.$store.commit('PROGRESS_FINISH')
				}).catch(() => {
					localStorage.setItem('prospect_data', '');
					this.$store.commit('PROGRESS_FAIL')
				});
			},
		},
		created(){
			this.$store.dispatch('setPageTitle', this.$route.params.code);
			this.getProductDetail(this.$route.params.code);
			this.getStockistByProvince();
			this.getStockistByProduct({
				product_code: this.$route.params.code,
				'limit':12,
				'lat': this.location.lat,
				'lng': this.location.lng
			})
			if (this.$route.query.sponsor) {
				this.dataSponsor = this.$route.query.sponsor
				this.cekSponsor()
			}
			if (this.$route.query.prospek_id) {
				this.dataProspect = this.$route.query.prospek_id
				this.cekProspect()
			}
		},
		watch: {
			location: {
				deep: true,
				handler: function(val , old) {
					if (val.lat != old.lat) {
						this.getStockistByProduct({
							product_code: this.$route.params.code,
							'limit':12,
							'lat': this.location.lat,
							'lng': this.location.lng
						})
					}
				}
			},
			'$route.params.code'(id){
				this.getProductDetail(id);
				this.getStockistByProduct({
					product_code: id,
					'limit':12,
					'lat': this.location.lat,
					'lng': this.location.lng
				})
			}
		},
		filters: {
			truncate: function (text, length, suffix) {
				return text.substring(0, length) + suffix;
			},
		},
		async beforeRouteUpdate (to, from, next) {
			await this.$refs.modalBerhasilDitambah.modalHide()
			await next()
		},
		async beforeRouteLeave(to, from, next) {
			await this.$refs.modalBerhasilDitambah.modalHide()
			await next()
		}
	}
	</script>

	<style>
	.nav-pills .nav-link.active {
		background-image: linear-gradient(to right, #7C1CC6, #460C94);
		color: #fff !important;
	}
	</style>